import { QueryClient, QueryClientProvider } from '@tanstack/react-query';
import { AuthProvider } from '../context/AuthContext';
import { AppProvider } from '../context/AppContext';
import { ToastProvider } from '../context/ToastContext';
import { DatabaseModeProvider } from '../context/DatabaseModeContext';
import ErrorBoundary from '../components/ErrorBoundary';
import theme from '../theme';
import { ThemeProvider, StyledEngineProvider } from '@mui/material';

const queryClient = new QueryClient();

export const AppProviders: React.FC<{ children: React.ReactNode }> = ({ children }) => {
  return (
    <StyledEngineProvider injectFirst>
      <ThemeProvider theme={theme}>
        <ErrorBoundary fallback={<div>Something went wrong</div>}>
          <QueryClientProvider client={queryClient}>
            <DatabaseModeProvider>
              <AuthProvider>
                <AppProvider>
                  <ToastProvider>
                    {children}
                  </ToastProvider>
                </AppProvider>
              </AuthProvider>
            </DatabaseModeProvider>
          </QueryClientProvider>
        </ErrorBoundary>
      </ThemeProvider>
    </StyledEngineProvider>
  );
};

export default AppProviders;
